<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 128.84 53.463">
    <g id="Hybrid" transform="translate(10739.465 -30.099)">
      <path id="Path_87074" data-name="Path 87074"
        d="M44.254,354.109a10.658,10.658,0,1,0,10.657,10.654,10.668,10.668,0,0,0-10.657-10.654m.006,19.214a8.569,8.569,0,1,1,8.569-8.569,8.579,8.579,0,0,1-8.569,8.569"
        transform="translate(-10677.136 -291.855)" :fill="themeColor" />
      <path id="Path_87075" data-name="Path 87075"
        d="M16.455,354.109a10.656,10.656,0,1,0,10.657,10.654,10.67,10.67,0,0,0-10.657-10.654m.006,19.214a8.569,8.569,0,1,1,8.569-8.569,8.579,8.579,0,0,1-8.569,8.569"
        transform="translate(-10728.745 -291.855)" :fill="themeColor" />
      <path id="Path_87076" data-name="Path 87076"
        d="M31.056,361.413c8.877,0,54.315.231,62.955.277l0-.437,1.791.254a66.674,66.674,0,0,0,7.038,1.594c7.538,1.542,13.456,2.851,15.861,4.542,3.6,2.528,6.047,13.973,6.689,18.172a1.084,1.084,0,0,0,.394.746,1.111,1.111,0,0,0,.763.217,1.05,1.05,0,0,0,.7-.388,1.034,1.034,0,0,0,.217-.763l1.391-.346-1.411.217c-1.123-7.363-3.77-16.9-7.549-19.557-2.931-2.065-10.134-3.545-16.489-4.85a74,74,0,0,1-10.674-2.631,35.88,35.88,0,0,1-7.269-5.081,42.611,42.611,0,0,0-11.04-7.244c-13.028-5.01-42.579-3.622-55.343-.263l-11.265.78a1.04,1.04,0,0,0-.066,2.059l1.205-.069,4.019-.271-2.951,2.745a38.886,38.886,0,0,0-6.555,7.858.972.972,0,0,0-.123.363l-1.58,11.616-1.691,5a1.015,1.015,0,0,0-.014.631c1.957,6.632,4.764,10.134,8.12,10.134h2.085a1.03,1.03,0,0,0,.734-.3,1.019,1.019,0,0,0,.306-.731,1.038,1.038,0,0,0-1.037-1.043H8.18c-2.148,0-4.3-2.871-5.9-7.875l-.143-.451,1.6-4.642L5.546,359.56a37.056,37.056,0,0,1,9.606-10.014c6.124-4.1,43.084-7.412,58.6-1.442a41.2,41.2,0,0,1,10.5,6.975c.631.571,1.314,1.085,2,1.6l3.842,2.913-4.279-.023c-16.115-.08-47.52-.237-54.755-.237-6.547,0-10.08-1.662-10.934-3.091l-.031.017a1.041,1.041,0,1,0-1.831.991c.28.486,2.679,4.164,12.8,4.164"
        transform="translate(-10739.483 -312.753)" :fill="themeColor" />
      <path id="Path_87077" data-name="Path 87077"
        d="M61.472,359.554a1.04,1.04,0,0,0,0-2.079H16.24a1.044,1.044,0,0,0-.737.306,1.021,1.021,0,0,0-.306.734,1.045,1.045,0,0,0,.3.734,1.032,1.032,0,0,0,.737.306H61.472Z"
        transform="translate(-10711.309 -285.607)" :fill="themeColor" />
      <path id="Path_87078" data-name="Path 87078" d="M33.423,349.95h0Z" transform="translate(-10677.481 -299.576)"
        :fill="themeColor" />
      <path id="Path_87079" data-name="Path 87079" d="M33.423,349.95h0Z" transform="translate(-10677.481 -299.576)"
        fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="1" />
    </g>
  </svg>

</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
